import superAdminAxiosInstance from "../../scenes/utils/superAdminAxiosInstance";
import { API_ENDPOINTS } from "../../config/api";

class LogService {
  /**
   * Trash log listesini getirir (pagination ve filtering ile)
   * @param {Object} params - Pagination ve filter parametreleri
   * @param {number} params.pageIndex - Sayfa indexi (0-based, default: 0)
   * @param {number} params.limit - Sayfa başına kayıt sayısı (default: 20)
   * @param {string} params.sortBy - Sıralama alanı (default: 'createdAt')
   * @param {string} params.sortOrder - Sıralama yönü ('ASC' | 'DESC', default: 'DESC')
   * @param {string} params.entityType - Entity tipine göre filtreleme
   * @param {string} params.entityId - Entity ID'sine göre filtreleme
   * @param {string} params.operation - Operation tipine göre filtreleme ('UPDATE' | 'DELETE')
   * @param {boolean} params.onlyActive - Sadece süresi dolmamış kayıtlar
   * @param {string} params.fileName - File adına göre filtreleme
   * @returns {Promise<{data: Array, pagination: Object}>}
   */
  async getTrashLogs(params = {}) {
    // Pagination headers
    const headers = {
      'x-bone-pageindex': params.pageIndex || 0,
      'x-bone-limit': params.limit || 20,
      'x-bone-sortby': params.sortBy || 'createdAt',
      'x-bone-sortorder': params.sortOrder || 'DESC',
    };

    // Query parameters
    const queryParams = new URLSearchParams();
    if (params.entityType) queryParams.append('entityType', params.entityType);
    if (params.entityId) queryParams.append('entityId', params.entityId);
    if (params.operation) queryParams.append('operation', params.operation);
    if (params.onlyActive === true || params.onlyActive === 'true') {
      queryParams.append('onlyActive', 'true');
    }
    if (params.fileName) queryParams.append('fileName', params.fileName);

    const url = `${API_ENDPOINTS.SUPER_ADMIN.TRASH_LOGS.ALL}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    const response = await superAdminAxiosInstance.get(url, { headers });
    
    // Response headers'dan pagination bilgilerini al
    const pagination = {
      totalCount: parseInt(response.headers['x-total-count'] || 0, 10),
      pageIndex: parseInt(response.headers['x-page-index'] || 0, 10),
      page: parseInt(response.headers['x-page'] || 1, 10),
      pageSize: parseInt(response.headers['x-page-size'] || 20, 10),
      totalPages: parseInt(response.headers['x-total-pages'] || 1, 10),
    };

    return {
      data: response.data,
      pagination
    };
  }

  /**
   * Tek bir trash log kaydını ID ile getirir
   * @param {string} logId - Trash log ID'si
   * @returns {Promise<Object>}
   */
  async getTrashLogById(logId) {
    const response = await superAdminAxiosInstance.get(API_ENDPOINTS.SUPER_ADMIN.TRASH_LOGS.BY_ID(logId));
    return response.data;
  }

  /**
   * Rollback için OTP ister
   * @param {string} trashLogId - Trash log ID'si
   * @returns {Promise<Object>}
   */
  async requestRollbackOtp(trashLogId) {
    const response = await superAdminAxiosInstance.post(API_ENDPOINTS.SUPER_ADMIN.TRASH_LOGS.REQUEST_OTP, {
      trashLogId
    });
    return response.data;
  }

  /**
   * Silinen/güncellenen kaydı geri yükler (rollback)
   * @param {string} trashLogId - Trash log ID'si
   * @param {string} otp - OTP kodu
   * @returns {Promise<Object>}
   */
  async rollbackFromTrash(trashLogId, otp) {
    const response = await superAdminAxiosInstance.post(API_ENDPOINTS.SUPER_ADMIN.TRASH_LOGS.ROLLBACK, {
      trashLogId,
      otp
    });
    return response.data;
  }
}

export default new LogService();

